/*
 * @Author: venler
 * @Date: 2023-03-28 19:27:24
 * @LastEditors: venlerwei
 * @LastEditTime: 2023-03-28 19:35:06
 * @Description: 二次封装下组件，封装去升级逻辑
 */
import React, { useCallback } from 'react';
import UpdateAlertCom, {
  UpdateAlertProps,
} from '@tencent/calendar-web-component-pc-biz/es/UpdateAlert';
import useCommercialize from '@hooks/useCommercialize';

const UpdateAlert: React.FC<UpdateAlertProps> = (props) => {
  const { onBtnClick } = props;
  const { goUpdate } = useCommercialize();

  const handleClick = useCallback(() => {
    if (onBtnClick) {
      onBtnClick?.();
      return;
    }
    goUpdate();
  }, [onBtnClick, goUpdate]);

  return <UpdateAlertCom {...props} onBtnClick={handleClick} />;
};

export default UpdateAlert;
